import React, { Component } from 'react';
import './MonitoringJumbo.css'
import Charts from './Charts'
import InformationCards from '../InformationCards/InformationCards';
import { connect } from 'react-redux'
import { getChartData, getSelectedMonthData, getSelectedDay, getSelectedDayFromWeek } from '../../../../Actions/FirebaseDataAction';



class MonitoringJumbo extends Component {
    state = {
        s_chart_days_in_month : [],
        s_daily_data: [this.props.twelveA, this.props.oneA, this.props.twoA,this.props.threeA,this.props.fourA,
                        this.props.fiveA, this.props.sixA, this.props.sevenA, this.props.eightA, this.props.nineA, this.props.tenA,
                        this.props.elevenA, this.props.twelveP, this.props.oneP, this.props.twoP, this.props.threeP, this.props.fourP,
                        this.props.fiveP, this.props.sixP, this.props.sevenP, this.props.eightP, this.props.nineP, this.props.tenP, this.props.elevenP],

        s_monthly_data: [this.props.firstDayOfMonth, this.props.secondDayOfMonth, this.props.thirdDayOfMonth, this.props.fourthDayOfMonth, 
                        this.props.fifthDayOfMonth, this.props.sixthDayOfMonth, this.props.seventhDayOfMonth, this.props.eighthDayOfMonth],

        s_weekly_data: [this.props.firstWeek, this.props.secondWeek, this.props.thirdWeek, this.props.fourthWeek, this.props.fifthWeek, this.props.sixthWeek, this.props.seventhWeek],
    
        s_annual_data: [this.props.janCurrent, this.props.febCurrent, this.props.marchCurrent, this.props.aprilCurrent, this.props.mayCurrent, this.props.juneCurrent, this.props.julyCurrent, this.props.augCurrent, this.props.septCurrent, 
                        this.props.octCurrent, this.props.novCurrent, this.props.decCurrent],
        
        s_previous_annual_data: [this.props.janPrevious, this.props.febPrevious, this.props.marchPrevious, this.props.aprilPrevious, this.props.mayPrevious, this.props.junePrevious,
                                this.props.julyPrevious, this.props.augPrevious, this.props.septPrevious, this.props.octPrevious, this.props.novPrevious, this.props.decPrevious],
        s_last_year_button_class: "inactiveChart",
        s_this_year_button_class: "activeChart",
        s_chart_data: '',
        s_set_chart_labels: '',
        s_chart_title:'' ,
        s_charts: 1,
        //tells you what date range you are looking at, ex May 2018 or 4/5/2018-4/12/2018
        s_chart_date: "",
        s_last_7_days: ''
        
    }

    componentWillMount() {
        this.f_days_in_month(this.props.month, this.props.year);
        this.f_get_last_7_days();
        
    }

    //check to see if the graph props have changed, if they did return true else return false
    shouldComponentUpdate(nextProps, nextState){
        //if shouldComponentUpdata detects a change the update the changed component
        //s_charts changes when a chart nav button is clicked, so the component should update and we need to check that for it to happen
        //if a bar graph bar is clicked we need to check the new data that was loaded 
        if(nextState.s_charts != this.state.s_charts || nextProps.annualSelectedMonth != this.props.annualSelectedMonth || nextProps.selectedDay != this.props.selectedDay || nextProps.selectedDayFromWeek != this.props.selectedDayFromWeek) {
            console.log('true')
            return true
        } else {
            console.log('false')
            
            return false
        }
    }

    //when you click on a bar update the data with the new data
        componentDidUpdate (prevProps,prevState){

                var dataAnnual = this.props.annualSelectedMonth
                var dataDay = this.props.selectedDay
                var dataWeek = this.props.selectedDayFromWeek

                if(dataAnnual != prevProps.annualSelectedMonth){

                    this.setState({
                        s_chart_data: [dataAnnual.First,dataAnnual.Second, dataAnnual.Third, dataAnnual.Fourth, dataAnnual.Fifth, dataAnnual.Sixth, dataAnnual.Seventh, dataAnnual.Eigth, dataAnnual.Ninth, dataAnnual.Tenth, dataAnnual.Eleventh]
                    })
                    this.f_make_selected_month_active(this.state.s_chart_date);
                }

                if(dataDay != prevProps.selectedDay){
                    this.setState({
                        s_chart_data: [dataDay.twelveA,dataDay.oneA, dataDay.twoA, dataDay.threeA, dataDay.fourA, dataDay.fiveA, dataDay.sixA, dataDay.sevenA, dataDay.eightA, dataDay.nineA, dataDay.tenA, dataDay.elevenA,
                            dataDay.twelveP, dataDay.oneP, dataDay.twoP, dataDay.threeP, dataDay.fourP, dataDay.fiveP, dataDay.sixP, dataDay.sevenP, dataDay.eightP, dataDay.nineP, dataDay.tenP, dataDay.elevenP]
                    })
                        this.f_make_selected_day_active(this.state.s_chart_date)
                    }
            
                    if(dataWeek != prevProps.selectedDayFromWeek){
                    this.setState({
                        s_chart_data: [dataWeek.twelveA,dataWeek.oneA, dataWeek.twoA, dataWeek.threeA, dataWeek.fourA, dataWeek.fiveA, dataWeek.sixA, dataWeek.sevenA, dataWeek.eightA, dataWeek.nineA, dataWeek.tenA, dataWeek.elevenA,
                        dataWeek.twelveP, dataWeek.oneP, dataWeek.twoP, dataWeek.threeP, dataWeek.fourP, dataWeek.fiveP, dataWeek.sixP, dataWeek.sevenP, dataWeek.eightP, dataWeek.nineP, dataWeek.tenP, dataWeek.elevenP]
                    })
                    this.f_make_selected_day_active(this.state.s_chart_date)
                }
            }
        
    
//get the number of days in month
    f_days_in_month = (month, year) => {
        var numberOfDays = new Date(year, month,0).getDate();
        var daysArray = [];
        
        for(var i = 0; i < numberOfDays; i++ ){
            var d = i + 1;
            daysArray.push(d.toString());
            
        }
        this.setState({
            s_chart_days_in_month: daysArray
        })

        this.f_set_chart_daily_current();
    }

    f_get_last_7_days = () => {
        var last7 = [];
        
        for (var i =0; i<7; i++) {
            var d = new Date();
            var dd;
            var mm;
            var yyyy;

            d.setDate(d.getDate() - i);
            dd = d.getDate();
            mm = d.getMonth()+1;
            yyyy = d.getFullYear();
            if(dd<10) {dd=dd}
            var date = mm+'/'+dd+'/'+yyyy;
            last7.push( date );
            
        
        }
        
        this.setState({
            s_last_7_days : last7.reverse()
        })
    }
    //current years charts
    f_set_chart_daily_current = () => {
        this.setState({
            s_charts: this.state.s_charts + 1,
            s_chart_data: this.state.s_daily_data,
            s_set_chart_labels: ["12:00a","1:00a","2:00a","3:00a","4:00a","5:00a","6:00a","7:00a","8:00a","9:00a","10:00a","11:00a","12:00p","1:00p","2:00p","3:00p","4:00p","5:00p","6:00p","7:00p","8:00p","9:00p","10:00p","11:00p"],
            s_chart_title: "Daily" ,
            s_chart_date: this.props.today

        })
    }
    f_set_chart_weekly_current = () => {
        this.setState({
            s_charts: this.state.s_charts + 1,
            s_chart_data:this.state.s_weekly_data,
            s_set_chart_labels: this.state.s_last_7_days,
            s_chart_title: "Weekly",
            s_chart_date: this.props.sevenDaysAgo + "-" + this.props.today

        })
    }
    f_set_chart_monthly_current = () => {
        this.setState({
            s_charts: this.state.s_charts + 1,
            s_chart_data: this.state.s_monthly_data,
            s_set_chart_labels: this.state.s_chart_days_in_month,
            s_chart_title:"Monthly",
            s_chart_date: this.props.monthAsWord  + " " + this.props.year

        })
    }
    f_set_chart_annual_current = () => {
        this.setState({
            s_last_year_button_class: 'inactiveChart',
            s_this_year_button_class: 'activeChart',
            s_charts: this.state.s_charts + 1,
            s_chart_data: this.state.s_annual_data,
            s_set_chart_labels: ["Jan " + this.props.year,"Feb " + this.props.year, "March " + this.props.year, "April " + this.props.year, "May " + this.props.year,
            "June " + this.props.year, "July " + this.props.year, "Aug " + this.props.year, "Sept " + this.props.year, 'Oct ' + this.props.year , 'Nov '+ this.props.year, 'Dec '+ this.props.year],
            s_chart_title:this.props.year + " Annually",
            s_chart_date: "Annual"

        })
    }


    f_make_last_year_active = () => {
        this.setState({
            s_last_year_button_class: 'activeChart',
            s_this_year_button_class: 'inactiveChart',
            s_charts: this.state.s_charts + 1,
            s_chart_data: this.state.s_previous_annual_data,
            s_set_chart_labels: ["Jan " + this.props.lastYear,"Feb " + this.props.lastYear, "March " + this.props.lastYear, "April " + this.props.lastYear, "May " + this.props.lastYear, "June " + this.props.lastYear, "July " + this.props.lastYear, "Aug " + this.props.lastYear, "Sept "+ this.props.lastYear, 'Oct '+ this.props.lastYear , 'Nov ' + this.props.lastYear, 'Dec '+ this.props.lastYear],
            s_chart_title: this.props.lastYear + " Annually",
            s_chart_date: "Annual"

        })
    }

    f_make_this_year_active = () => {
        this.setState({
    
            s_last_year_button_class: 'inactiveChart',
            s_this_year_button_class: 'activeChart',
            s_charts: this.state.s_charts + 1,
            s_chart_data: this.state.s_annual_data,
            s_set_chart_labels: ["Jan " + this.props.year,"Feb " + this.props.year, "March " + this.props.year, "April " + this.props.year, "May " + this.props.year,
            "June " + this.props.year, "July " + this.props.year, "Aug " + this.props.year, "Sept " + this.props.year, 'Oct ' + this.props.year , 'Nov '+ this.props.year, 'Dec '+ this.props.year],
            s_chart_title: this.props.year +" Annually",
            s_chart_date: "Annual"
        })
    }

    //get the bar that was clicked in the graph and load the proper data 
    //label is the label of the column that was clicked
    f_get_selected_bar= (label) => {
        if(label.indexOf(':') > -1) {
            console.log('on daily chart')
        }
    
        //selected a bar on the annual graph
        if(label.length>=8){
            this.setState({
                s_chart_date: label,
                s_chart_title: " ",
            })
                this.props.getSelectedMonth(label);
        } 
        //selected a bar on the monthly graph
        if(label.length < 3) {
            //selected day onclick
        
            //split the chart date into an array to separate the Month and Year ex. [May, 2018]
            
            var monthAndYearArray = this.state.s_chart_date.split(' ');
            this.setState({
                s_chart_date: monthAndYearArray[0] + " " + label + " " + monthAndYearArray[1]
            })
            this.props.getSelectedDay(label,monthAndYearArray[0],monthAndYearArray[1]);
        }

        //selected a bar on the weekly graph
        if(label.indexOf('/') > -1){
            console.log(label)
            this.props.getSelectedDayFromWeek(label);
        }
        
    }

    f_make_selected_month_active = (month) => {
            this.setState({
                s_charts: this.state.s_charts + 1,
                s_set_chart_labels: this.state.s_chart_days_in_month,
                
                
            })
    }

    f_make_selected_day_active = (day) => {
        this.setState({
        s_charts: this.state.s_charts +1,
        s_set_chart_labels: ["12:00a","1:00a","2:00a","3:00a","4:00a","5:00a","6:00a","7:00a","8:00a","9:00a","10:00a","11:00a","12:00p","1:00p","2:00p","3:00p","4:00p","5:00p","6:00p","7:00p","8:00p","9:00p","10:00p","11:00p"],
    })
    }


    render() { 
        return (
        <div>
                {
                    

                    this.props.monitoring === "SolarEdge" ? 
                    <div className ="row">
                        <div className="col-xl-4">
                            <div className="leftMonitoringPanel">
                                <InformationCards title="Today your system has produced..." style="2px solid #b93088" icon="far fa-calendar-alt" iconColor="#b93088" body={this.props.energyToday + ' kWh'} display="none" columnClass="col-xl-12"/> 
                            </div>
                            <div className="leftMonitoringPanel">
                                <InformationCards title="This month your system has produced..." style="2px solid #2cabf7" icon="far fa-calendar-check" iconColor="#2cabf7" body={this.props.energyMonth + ' kWh'} display="none" columnClass="col-xl-12"/> 
                            </div>
                            <div className="leftMonitoringPanel">
                                <InformationCards title="Over the lifetime of your system, you have produced..." style="2px solid #00b58c" icon="fas fa-battery-full" iconColor="#00b58c" body={this.props.lifetime + ' kWh'} display="none" columnClass="col-xl-12"/> 
                            </div>
                            <div className="leftMonitoringPanel">
                                <InformationCards title="You are currently producing..." style="2px solid #f7ce3c" icon=" fas fa-bolt" iconColor="#f7ce3c" body={this.props.current + ' kWh'} display="none" columnClass="col-xl-12"/> 
                            </div>
                        </div>
                        <div className="col-xl-8">
                            <div className=" chart-parent">
                            
                                <nav className="navbar navbar-expand-lg navbar-light" style={{position: "relative",}}>
                                    <div className="navbar-collapse" id="navbarNav">
                                    <h3 className="chartLabel miniHeadings">Your Solar Energy Production </h3>
                                    <span style={{fontSize: "20px"}}>
                                            {
                                                this.state.s_chart_date === "Annual" ? 
                                                    <div> <span className={this.state.s_last_year_button_class} onClick={this.f_make_last_year_active}>{this.props.lastYear}</span>
                                                    <span> </span>  
                                                    <span className={this.state.s_this_year_button_class} onClick={this.f_make_this_year_active}>{this.props.year}</span></div> 
                                                :
                                                this.state.s_chart_date
                                            }
            
                                        </span>
                                        <ul className="navbar-nav ml-auto">
                                            <li className="nav-item">
                                                <a className="nav-link"onClick={this.f_set_chart_daily_current} >Daily</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" onClick={this.f_set_chart_weekly_current}>Weekly</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link"onClick={this.f_set_chart_monthly_current} >Monthly</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" onClick={this.f_set_chart_annual_current}>Annually</a>
                                            </li>
                                        </ul>
                                    </div>
                                </nav>
            
                                
                                {
                                    //remove the s_charts from the dom and add the new chart with the updated data
                                    this.state.s_charts % 2 === 0 ? 
                                    <Charts fp_get_selected_bar={this.f_get_selected_bar}data={this.state.s_chart_data} chartLabels={this.state.s_set_chart_labels} title={this.state.s_chart_title}/> 
                                    :
                                    <div></div> 
                                }
            
                                {
                                    this.state.s_charts % 2 === 1 ? 
                                    <Charts fp_get_selected_bar={this.f_get_selected_bar} data={this.state.s_chart_data} chartLabels={this.state.s_set_chart_labels} title={this.state.s_chart_title}/> 
                                    :
                                    <div></div>
                                }
                                
                                
                            </div>
                        </div>
                    </div>

                :

                <div>
                    <iframe src="https://monitor.us.sunpower.com/#/login" frameborder="0" width="100%" height="800px"></iframe>
                </div>

                }
            
        </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        annualSelectedMonth: state.selectedMonthChart.selectedMonth,
        selectedDay: state.selectedDayChart.selectedDay,
        selectedDayFromWeek: state.selectedDayFromWeekChart.selectedDayFromWeek
    }
  }

const mapDispatchToProps = (dispatch) => {
    return {
        getSelectedMonth: (label) => dispatch(getSelectedMonthData(label)),
        getSelectedDay: (label,month,year) => dispatch(getSelectedDay(label,month,year)),
        getSelectedDayFromWeek: (label) => dispatch(getSelectedDayFromWeek(label))
    }
}

export default connect(mapStateToProps, mapDispatchToProps) (MonitoringJumbo);


// WEBPACK FOOTER //
// ./src/Components/Pages/MyHaven/MonitoringJumbo/MonitoringJumbo.jsx